import script from "./parameter-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./parameter-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./parameter-drawer.vue?vue&type=style&index=0&id=c2fae6b2&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2fae6b2"]])

export default __exports__